module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mail.35d13ac1.png";